import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpSearchProductGridComponent} from './dcp-search-product-grid.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {MediaModule, ProductListModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {ProductTileModule} from '../../shared/product-tile/product-tile.module';

@NgModule({
  declarations: [
    DcpSearchProductGridComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SearchResultsGridComponent: {
          component: DcpSearchProductGridComponent
        },
      }
    }),
    ProductListModule,
    RouterModule,
    MediaModule,
    ProductTileModule,
    I18nModule
  ],
  exports: [
    DcpSearchProductGridComponent
  ]
})
export class DcpSearchProductGridModule {
}
